// List of countries from ISO 3166 obtained 2025-05-22. See https://www.iso.org/obp/ui/#search
// For countries that officially end in only " (the)" we omit that part.

const countryList = [
    { code: 'AD', countryID: 1, name: 'Andorra' },
    { code: 'AE', countryID: 2, name: 'United Arab Emirates' },
    { code: 'AF', countryID: 3, name: 'Afghanistan' },
    { code: 'AG', countryID: 4, name: 'Antigua and Barbuda' },
    { code: 'AI', countryID: 5, name: 'Anguilla' },
    { code: 'AL', countryID: 6, name: 'Albania' },
    { code: 'AM', countryID: 7, name: 'Armenia' },
    { code: 'AO', countryID: 9, name: 'Angola' },
    { code: 'AQ', countryID: 10, name: 'Antarctica' },
    { code: 'AR', countryID: 11, name: 'Argentina' },
    { code: 'AS', countryID: 12, name: 'American Samoa' },
    { code: 'AT', countryID: 13, name: 'Austria' },
    { code: 'AU', countryID: 14, name: 'Australia' },
    { code: 'AW', countryID: 15, name: 'Aruba' },
    { code: 'AX', countryID: 240, name: 'Åland Islands' },
    { code: 'AZ', countryID: 16, name: 'Azerbaijan' },
    { code: 'BA', countryID: 17, name: 'Bosnia and Herzegovina' },
    { code: 'BB', countryID: 18, name: 'Barbados' },
    { code: 'BD', countryID: 19, name: 'Bangladesh' },
    { code: 'BE', countryID: 20, name: 'Belgium' },
    { code: 'BF', countryID: 21, name: 'Burkina Faso' },
    { code: 'BG', countryID: 22, name: 'Bulgaria' },
    { code: 'BH', countryID: 23, name: 'Bahrain' },
    { code: 'BI', countryID: 24, name: 'Burundi' },
    { code: 'BJ', countryID: 25, name: 'Benin' },
    { code: 'BL', countryID: 247, name: 'Saint Barthélemy' },
    { code: 'BM', countryID: 26, name: 'Bermuda' },
    { code: 'BN', countryID: 27, name: 'Brunei Darussalam' },
    { code: 'BO', countryID: 28, name: 'Bolivia (Plurinational State of)' },
    { code: 'BQ', countryID: 241, name: 'Bonaire, Sint Eustatius and Saba' },
    { code: 'BR', countryID: 29, name: 'Brazil' },
    { code: 'BS', countryID: 30, name: 'Bahamas' },
    { code: 'BT', countryID: 31, name: 'Bhutan' },
    { code: 'BV', countryID: 32, name: 'Bouvet Island' },
    { code: 'BW', countryID: 33, name: 'Botswana' },
    { code: 'BY', countryID: 34, name: 'Belarus' },
    { code: 'BZ', countryID: 35, name: 'Belize' },
    { code: 'CA', countryID: 36, name: 'Canada' },
    { code: 'CC', countryID: 37, name: 'Cocos (Keeling) Islands' },
    { code: 'CD', countryID: 38, name: 'Congo (the Democratic Republic of the)' },
    { code: 'CF', countryID: 39, name: 'Central African Republic' },
    { code: 'CG', countryID: 40, name: 'Congo' },
    { code: 'CH', countryID: 41, name: 'Switzerland' },
    { code: 'CI', countryID: 42, name: 'Côte d\'Ivoire' },
    { code: 'CK', countryID: 43, name: 'Cook Islands' },
    { code: 'CL', countryID: 44, name: 'Chile' },
    { code: 'CM', countryID: 45, name: 'Cameroon' },
    { code: 'CN', countryID: 46, name: 'China' },
    { code: 'CO', countryID: 47, name: 'Colombia' },
    { code: 'CR', countryID: 48, name: 'Costa Rica' },
    { code: 'CU', countryID: 50, name: 'Cuba' },
    { code: 'CV', countryID: 51, name: 'Cabo Verde' },
    { code: 'CW', countryID: 242, name: 'Curaçao' },
    { code: 'CX', countryID: 52, name: 'Christmas Island' },
    { code: 'CY', countryID: 53, name: 'Cyprus' },
    { code: 'CZ', countryID: 54, name: 'Czechia' },
    { code: 'DE', countryID: 55, name: 'Germany' },
    { code: 'DJ', countryID: 56, name: 'Djibouti' },
    { code: 'DK', countryID: 57, name: 'Denmark' },
    { code: 'DM', countryID: 58, name: 'Dominica' },
    { code: 'DO', countryID: 59, name: 'Dominican Republic' },
    { code: 'DZ', countryID: 60, name: 'Algeria' },
    { code: 'EC', countryID: 61, name: 'Ecuador' },
    { code: 'EE', countryID: 62, name: 'Estonia' },
    { code: 'EG', countryID: 63, name: 'Egypt' },
    { code: 'EH', countryID: 64, name: 'Western Sahara' },
    { code: 'ER', countryID: 65, name: 'Eritrea' },
    { code: 'ES', countryID: 66, name: 'Spain' },
    { code: 'ET', countryID: 67, name: 'Ethiopia' },
    { code: 'FI', countryID: 68, name: 'Finland' },
    { code: 'FJ', countryID: 69, name: 'Fiji' },
    { code: 'FK', countryID: 70, name: 'Falkland Islands (Malvinas)' }, // Officially: Falkland Islands (the) [Malvinas]. Used parentheses instead of square brackets for consistency with other countries.
    { code: 'FM', countryID: 71, name: 'Micronesia (Federated States of)' },
    { code: 'FO', countryID: 72, name: 'Faroe Islands' },
    { code: 'FR', countryID: 73, name: 'France' },
    { code: 'GA', countryID: 74, name: 'Gabon' },
    { code: 'GB', countryID: 75, name: 'United Kingdom' }, // Officially: United Kingdom of Great Britain and Northern Ireland (the). Common name used instead.
    { code: 'GD', countryID: 76, name: 'Grenada' },
    { code: 'GE', countryID: 77, name: 'Georgia' },
    { code: 'GF', countryID: 78, name: 'French Guiana' },
    { code: 'GG', countryID: 243, name: 'Guernsey' },
    { code: 'GH', countryID: 79, name: 'Ghana' },
    { code: 'GI', countryID: 80, name: 'Gibraltar' },
    { code: 'GL', countryID: 81, name: 'Greenland' },
    { code: 'GM', countryID: 82, name: 'Gambia' },
    { code: 'GN', countryID: 83, name: 'Guinea' },
    { code: 'GP', countryID: 84, name: 'Guadeloupe' },
    { code: 'GQ', countryID: 85, name: 'Equatorial Guinea' },
    { code: 'GR', countryID: 86, name: 'Greece' },
    { code: 'GS', countryID: 87, name: 'South Georgia and the South Sandwich Islands' },
    { code: 'GT', countryID: 88, name: 'Guatemala' },
    { code: 'GU', countryID: 89, name: 'Guam' },
    { code: 'GW', countryID: 90, name: 'Guinea-Bissau' },
    { code: 'GY', countryID: 91, name: 'Guyana' },
    { code: 'HK', countryID: 92, name: 'Hong Kong' },
    { code: 'HM', countryID: 93, name: 'Heard Island and McDonald Islands' },
    { code: 'HN', countryID: 94, name: 'Honduras' },
    { code: 'HR', countryID: 95, name: 'Croatia' },
    { code: 'HT', countryID: 96, name: 'Haiti' },
    { code: 'HU', countryID: 97, name: 'Hungary' },
    { code: 'ID', countryID: 98, name: 'Indonesia' },
    { code: 'IE', countryID: 99, name: 'Ireland' },
    { code: 'IL', countryID: 100, name: 'Israel' },
    { code: 'IM', countryID: 244, name: 'Isle of Man' },
    { code: 'IN', countryID: 101, name: 'India' },
    { code: 'IO', countryID: 102, name: 'British Indian Ocean Territory' },
    { code: 'IQ', countryID: 103, name: 'Iraq' },
    { code: 'IR', countryID: 104, name: 'Iran (Islamic Republic of)' },
    { code: 'IS', countryID: 105, name: 'Iceland' },
    { code: 'IT', countryID: 106, name: 'Italy' },
    { code: 'JE', countryID: 245, name: 'Jersey' },
    { code: 'JM', countryID: 107, name: 'Jamaica' },
    { code: 'JO', countryID: 108, name: 'Jordan' },
    { code: 'JP', countryID: 109, name: 'Japan' },
    { code: 'KE', countryID: 110, name: 'Kenya' },
    { code: 'KG', countryID: 111, name: 'Kyrgyzstan' },
    { code: 'KH', countryID: 112, name: 'Cambodia' },
    { code: 'KI', countryID: 113, name: 'Kiribati' },
    { code: 'KM', countryID: 114, name: 'Comoros' },
    { code: 'KN', countryID: 115, name: 'Saint Kitts and Nevis' },
    { code: 'KP', countryID: 116, name: 'Korea (Democratic People\'s Republic of)' },
    { code: 'KR', countryID: 117, name: 'Korea (the Republic of)' },
    { code: 'KW', countryID: 118, name: 'Kuwait' },
    { code: 'KY', countryID: 119, name: 'Cayman Islands' },
    { code: 'KZ', countryID: 120, name: 'Kazakhstan' },
    { code: 'LA', countryID: 121, name: 'Lao People\'s Democratic Republic' },
    { code: 'LB', countryID: 122, name: 'Lebanon' },
    { code: 'LC', countryID: 123, name: 'Saint Lucia' },
    { code: 'LI', countryID: 124, name: 'Liechtenstein' },
    { code: 'LK', countryID: 125, name: 'Sri Lanka' },
    { code: 'LR', countryID: 126, name: 'Liberia' },
    { code: 'LS', countryID: 127, name: 'Lesotho' },
    { code: 'LT', countryID: 128, name: 'Lithuania' },
    { code: 'LU', countryID: 129, name: 'Luxembourg' },
    { code: 'LV', countryID: 130, name: 'Latvia' },
    { code: 'LY', countryID: 131, name: 'Libya' },
    { code: 'MA', countryID: 132, name: 'Morocco' },
    { code: 'MC', countryID: 133, name: 'Monaco' },
    { code: 'MD', countryID: 134, name: 'Moldova (the Republic of)' },
    { code: 'ME', countryID: 246, name: 'Montenegro' },
    { code: 'MF', countryID: 248, name: 'Saint Martin (French part)' },
    { code: 'MG', countryID: 135, name: 'Madagascar' },
    { code: 'MH', countryID: 136, name: 'Marshall Islands' },
    { code: 'MK', countryID: 137, name: 'North Macedonia' },
    { code: 'ML', countryID: 138, name: 'Mali' },
    { code: 'MM', countryID: 139, name: 'Myanmar' },
    { code: 'MN', countryID: 140, name: 'Mongolia' },
    { code: 'MO', countryID: 141, name: 'Macao' },
    { code: 'MP', countryID: 142, name: 'Northern Mariana Islands' },
    { code: 'MQ', countryID: 143, name: 'Martinique' },
    { code: 'MR', countryID: 144, name: 'Mauritania' },
    { code: 'MS', countryID: 145, name: 'Montserrat' },
    { code: 'MT', countryID: 146, name: 'Malta' },
    { code: 'MU', countryID: 147, name: 'Mauritius' },
    { code: 'MV', countryID: 148, name: 'Maldives' },
    { code: 'MW', countryID: 149, name: 'Malawi' },
    { code: 'MX', countryID: 150, name: 'Mexico' },
    { code: 'MY', countryID: 151, name: 'Malaysia' },
    { code: 'MZ', countryID: 152, name: 'Mozambique' },
    { code: 'NA', countryID: 153, name: 'Namibia' },
    { code: 'NC', countryID: 154, name: 'New Caledonia' },
    { code: 'NE', countryID: 155, name: 'Niger' },
    { code: 'NF', countryID: 156, name: 'Norfolk Island' },
    { code: 'NG', countryID: 157, name: 'Nigeria' },
    { code: 'NI', countryID: 158, name: 'Nicaragua' },
    { code: 'NL', countryID: 159, name: 'Netherlands (Kingdom of the)' },
    { code: 'NO', countryID: 160, name: 'Norway' },
    { code: 'NP', countryID: 161, name: 'Nepal' },
    { code: 'NR', countryID: 162, name: 'Nauru' },
    { code: 'NU', countryID: 163, name: 'Niue' },
    { code: 'NZ', countryID: 164, name: 'New Zealand' },
    { code: 'OM', countryID: 165, name: 'Oman' },
    { code: 'PA', countryID: 166, name: 'Panama' },
    { code: 'PE', countryID: 167, name: 'Peru' },
    { code: 'PF', countryID: 168, name: 'French Polynesia' },
    { code: 'PG', countryID: 169, name: 'Papua New Guinea' },
    { code: 'PH', countryID: 170, name: 'Philippines' },
    { code: 'PK', countryID: 171, name: 'Pakistan' },
    { code: 'PL', countryID: 172, name: 'Poland' },
    { code: 'PM', countryID: 173, name: 'Saint Pierre and Miquelon' },
    { code: 'PN', countryID: 174, name: 'Pitcairn' },
    { code: 'PR', countryID: 175, name: 'Puerto Rico' },
    { code: 'PS', countryID: 176, name: 'Palestine, State of' },
    { code: 'PT', countryID: 177, name: 'Portugal' },
    { code: 'PW', countryID: 178, name: 'Palau' },
    { code: 'PY', countryID: 179, name: 'Paraguay' },
    { code: 'QA', countryID: 180, name: 'Qatar' },
    { code: 'RE', countryID: 181, name: 'Réunion' },
    { code: 'RO', countryID: 182, name: 'Romania' },
    { code: 'RS', countryID: 249, name: 'Serbia' },
    { code: 'RU', countryID: 183, name: 'Russian Federation' },
    { code: 'RW', countryID: 184, name: 'Rwanda' },
    { code: 'SA', countryID: 185, name: 'Saudi Arabia' },
    { code: 'SB', countryID: 186, name: 'Solomon Islands' },
    { code: 'SC', countryID: 187, name: 'Seychelles' },
    { code: 'SD', countryID: 188, name: 'Sudan' },
    { code: 'SE', countryID: 189, name: 'Sweden' },
    { code: 'SG', countryID: 190, name: 'Singapore' },
    { code: 'SH', countryID: 191, name: 'Saint Helena, Ascension and Tristan da Cunha' },
    { code: 'SI', countryID: 192, name: 'Slovenia' },
    { code: 'SJ', countryID: 193, name: 'Svalbard and Jan Mayen' },
    { code: 'SK', countryID: 194, name: 'Slovakia' },
    { code: 'SL', countryID: 195, name: 'Sierra Leone' },
    { code: 'SM', countryID: 196, name: 'San Marino' },
    { code: 'SN', countryID: 197, name: 'Senegal' },
    { code: 'SO', countryID: 198, name: 'Somalia' },
    { code: 'SR', countryID: 199, name: 'Suriname' },
    { code: 'SS', countryID: 251, name: 'South Sudan' },
    { code: 'ST', countryID: 200, name: 'Sao Tome and Principe' },
    { code: 'SV', countryID: 201, name: 'El Salvador' },
    { code: 'SX', countryID: 250, name: 'Sint Maarten (Dutch part)' },
    { code: 'SY', countryID: 202, name: 'Syrian Arab Republic' },
    { code: 'SZ', countryID: 203, name: 'Eswatini' },
    { code: 'TC', countryID: 204, name: 'Turks and Caicos Islands' },
    { code: 'TD', countryID: 205, name: 'Chad' },
    { code: 'TF', countryID: 206, name: 'French Southern Territories' },
    { code: 'TG', countryID: 207, name: 'Togo' },
    { code: 'TH', countryID: 208, name: 'Thailand' },
    { code: 'TJ', countryID: 209, name: 'Tajikistan' },
    { code: 'TK', countryID: 210, name: 'Tokelau' },
    { code: 'TL', countryID: 211, name: 'Timor-Leste' },
    { code: 'TM', countryID: 212, name: 'Turkmenistan' },
    { code: 'TN', countryID: 213, name: 'Tunisia' },
    { code: 'TO', countryID: 214, name: 'Tonga' },
    { code: 'TR', countryID: 215, name: 'Türkiye' },
    { code: 'TT', countryID: 216, name: 'Trinidad and Tobago' },
    { code: 'TV', countryID: 217, name: 'Tuvalu' },
    { code: 'TW', countryID: 218, name: 'Taiwan' }, // Officially: Taiwan (Province of China). Renamed due to client/customer complaint.
    { code: 'TZ', countryID: 219, name: 'Tanzania, the United Republic of' },
    { code: 'UA', countryID: 220, name: 'Ukraine' },
    { code: 'UG', countryID: 221, name: 'Uganda' },
    { code: 'UM', countryID: 222, name: 'United States Minor Outlying Islands' },
    { code: 'US', countryID: 223, name: 'United States of America' },
    { code: 'UY', countryID: 224, name: 'Uruguay' },
    { code: 'UZ', countryID: 225, name: 'Uzbekistan' },
    { code: 'VA', countryID: 226, name: 'Holy See (Vatican City State)' }, // Officially: Holy See (the). Vatican City added because it was there before.
    { code: 'VC', countryID: 227, name: 'Saint Vincent and the Grenadines' },
    { code: 'VE', countryID: 228, name: 'Venezuela (Bolivarian Republic of)' },
    { code: 'VG', countryID: 229, name: 'Virgin Islands (British)' },
    { code: 'VI', countryID: 230, name: 'Virgin Islands (U.S.)' },
    { code: 'VN', countryID: 231, name: 'Viet Nam' },
    { code: 'VU', countryID: 232, name: 'Vanuatu' },
    { code: 'WF', countryID: 233, name: 'Wallis and Futuna' },
    { code: 'WS', countryID: 234, name: 'Samoa' },
    { code: 'YE', countryID: 235, name: 'Yemen' },
    { code: 'YT', countryID: 236, name: 'Mayotte' },
    { code: 'ZA', countryID: 237, name: 'South Africa' },
    { code: 'ZM', countryID: 238, name: 'Zambia' },
    { code: 'ZW', countryID: 239, name: 'Zimbabwe' },
];

module.exports = countryList;
